export function MapLoading() {
	return (
		<div className="flex w-full h-full items-center justify-center">
			<span className="loading loading-spinner loading-lg text-gray-300"></span>
		</div>
	);
}
